if (!customElements.get('custom-content-slider')) {
  customElements.define(
    'custom-content-slider',
    class CustomContentSlider extends HTMLElement {
      constructor() {
        super();

        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.updateControls = this.updateControls.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.slider = this.querySelector('.custom-content-slider__viewport');
        this.sliderWrapper = this.querySelector('.custom-content-slider__items');
        this.controls = this.querySelector('.custom-content-slider__controls');
        this.nextButton = this.querySelector('.swiper-button-next');
        this.previousButton = this.querySelector('.swiper-button-prev');
        this.pagination = this.querySelector('.swiper-pagination');
        this.sectionId = this.dataset.sectionId;
        this.desktopItems = Number.parseInt(this.dataset.desktopItems, 10);
        this.tabletItems = Number.parseInt(this.dataset.tabletItems, 10);
        this.mobileItems = Number.parseInt(this.dataset.mobileItems, 10);

        if (!this.slider || !this.sliderWrapper || !this.sliderWrapper.children.length) return;

        this.initialized = true;
        this.initSlider();
        this.addEventListener('focusin', this.handleFocusIn);

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('focusin', this.handleFocusIn);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.destroySlider();
        this.initialized = false;
      }

      initSlider() {
        if (this.sliderInstance) return;

        const mobileGap = this.getSpaceBetween(['--f-column-gap-mobile']);
        const tabletGap = this.getSpaceBetween(['--f-column-gap-md', '--f-column-gap-mobile']);
        const desktopGap = this.getSpaceBetween([
          '--f-column-gap-lg',
          '--f-column-gap-md',
          '--f-column-gap-mobile',
        ]);
        const wideDesktopGap = this.getSpaceBetween([
          '--f-column-gap-xl',
          '--f-column-gap-lg',
          '--f-column-gap-md',
          '--f-column-gap-mobile',
        ]);
        this.sliderWrapper.classList.remove('f-grid');

        const sliderOptions = {
          slidesPerView: this.mobileItems,
          slidesPerGroup: 1,
          spaceBetween: mobileGap,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.previousButton,
          },
          pagination: {
            el: this.pagination,
            type: 'progressbar',
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
              spaceBetween: tabletGap,
            },
            1024: {
              slidesPerView: this.desktopItems,
              spaceBetween: desktopGap,
            },
            1280: {
              slidesPerView: this.desktopItems,
              spaceBetween: wideDesktopGap,
            },
          },
          loop: false,
          threshold: 2,
          watchOverflow: true,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.slider, sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();
        this.sliderInstance.slider.on('lock unlock breakpoint resize', this.updateControls);
        this.updateControls();
      }

      getSpaceBetween(properties) {
        const styles = window.getComputedStyle(this.sliderWrapper);
        const rootFontSize = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 10;

        for (const property of properties) {
          const value = styles.getPropertyValue(property).trim();
          if (!value) continue;

          const numericValue = Number.parseFloat(value);
          if (Number.isNaN(numericValue)) continue;

          return value.endsWith('rem') ? numericValue * rootFontSize : numericValue;
        }

        return 0;
      }

      destroySlider() {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        this.sliderInstance.slider.off('lock unlock breakpoint resize', this.updateControls);
        this.sliderInstance.slider.destroy();
        this.sliderInstance = null;
        this.sliderWrapper.classList.add('f-grid');
      }

      updateControls() {
        if (!this.controls || !this.sliderInstance || !this.sliderInstance.slider) return;

        this.controls.classList.toggle('custom-content-slider__controls--locked', this.sliderInstance.slider.isLocked);
      }

      handleBlockSelect(event) {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        const index = Number.parseInt(event.target.dataset.index, 10);
        if (Number.isNaN(index)) return;

        this.sliderInstance.slider.slideTo(index);
      }

      handleFocusIn(event) {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        const slide = event.target.closest('.custom-content-slider__slide');
        if (!slide || !this.contains(slide)) return;

        const index = this.sliderInstance.slider.slides.indexOf(slide);
        if (index >= 0) this.sliderInstance.slider.slideTo(index);
      }
    }
  );
}
